module.exports = __webpack_public_path__ + "static/media/fil.5b66dcda.svg";